import React, { useCallback } from 'react';
import styled from 'styled-components';

import SignatureField from '../SignatureField';
import TableDataCell from './TableDataCell';

const StyledSignatureFieldWrapper = styled.div`
height: 100%;
align-items: center;
justify-content: center;
padding-top: 1px;
`;

const TableFieldSignatureCell = ({

  focused,

  id,
  rowId,
  columnId,
  columnIdentifier,
  columnType,
  cellKey,
  fontColor,
  borderRadius,
  borderWidth,
  borderColor,
  backgroundColor,
  primaryColor,
  dangerColor,
  width,
  invalid,

  onChange,
  onFocus,
  onBlur,

  value,
  disabled,
  isMobileView,
  fieldMode,

  maxImageWidth,
  maxImageHeight,

  onLoadCompleted

}) => {

  const handleLoadCompleted = useCallback(() => {
    if (onLoadCompleted) onLoadCompleted(columnId);
  }, [columnId]);

  /**
 * If the column width is less than maxImageWidth then the column width
 * will be applied as the maxImageWidth so that images would be placed within
 * cell boundary
 */
  const validMaxImageWidth = width && width < maxImageWidth ? width : maxImageWidth;

  const handleChange = (fieldId, fieldIdentifier, fieldPositionId, dataUrl, signer) => {

    if (onChange) onChange(rowId, columnId, dataUrl, undefined, signer);

  };

  const handleFocus = (fieldId, fieldIdentifier, fieldPositionId, e) => {
    if (onFocus) onFocus(rowId, columnId, columnIdentifier, columnType, e);
  };

  const handleBlur = (fieldId, fieldIdentifier, fieldPositionId, e) => {
    if (onBlur) onBlur(rowId, columnId, columnIdentifier, columnType);
  }


  return (
    <TableDataCell
      key={cellKey}
      data-testid={`${id}-${rowId}-${columnId}-signautre-cell`}
      {...{
        disabled,
        focused,
        primaryColor,
        width,
        borderColor,
        borderWidth,
        backgroundColor,
        padding: 0,
        invalid,
      }}
    >
      <StyledSignatureFieldWrapper>
        <SignatureField
          disabled={disabled}
          hideButton
          value={value}
          onChange={handleChange}
          onLoadCompleted={handleLoadCompleted}
          onFocus={handleFocus}
          onBlur={handleBlur}
          maxImageWidth={validMaxImageWidth}
          maxImageHeight={maxImageHeight}
          fieldMode={fieldMode}
        />
      </StyledSignatureFieldWrapper>
    </TableDataCell>
  );
};

export default React.memo(TableFieldSignatureCell);
